const balicons = "(?:[ᬅᬓ-ᬳᭅ-ᭋ]\u1b34?\u1b44)*[ᬅᬓ-ᬳᭅ-ᭋ]\u1b34?";

const layouts = {
  "bali": {
    letters: {
      grid: [
        ["vowel0", "vowel1", "vowel2", "vowel3", "dvowel0", "dvowel1", "dvowel2", "dvowel3", "dvowel4", "dvowel5"],
        ["vowel4", "vowel5", "vowel6", "vowel7", "dvowel6", "dvowel7", "dvowel8", "dvowel9", "dvowel10", "dvowel11"],
        ["cons0", "cons1", "cons2", "cons3", "cons4", "cons5", "cons6", "cons7", "cons8", "cons9"],
        ["shift", "cons10", "cons11", "cons12", "cons13", "cons14", "cons15", "cons16", "cons17", "backspace"],
        ["numbers", "numbers", "punc0", "space", "space", "space", "zwnj", "punc1", "return", "return"]
      ],
      keys: {
        vowel: [
          [/$/, [
            ["ᬅ", "ᬇ", "ᬉ", "ᬏ",
              "ᬐ", "ᬑ", "ᬋ", "ᬍ"]
          ]]
        ],
        dvowel: [
          [RegExp(balicons + "[\u1b35\u1b37\u1b39\u1b40\u1b41\u1b43]$"), [
            ["", "", "", "\u1b02", "\u1b03", "\u1b04",
              "", "", "", "", "", ""],
            ["", "", "", "\u1b00", "\u1b01", "",
              "", "", "", "", "", ""]
          ]],
          [RegExp(balicons + "\u1b3e$"), [
            ["\u0008\u1b40", "", "\u1b36", "\u1b02", "\u1b03", "\u1b04",
              "", "", "", "", "", ""],
            ["", "", "", "\u1b00", "\u1b01", "",
              "", "", "", "", "", ""]
          ]],
          [RegExp(balicons + "[\u1b3e\u1b3f]?\u1b36$"), [
            ["\u0008\u1b37", "", "", "\u1b02", "\u1b03", "\u1b04",
              "", "\u1b38", "", "", "", ""],
            ["", "", "", "\u1b00", "\u1b01", "",
              "", "", "", "", "", ""]
          ]],
          [RegExp(balicons + "(?:[\u1b3e\u1b3f]?\u1b36)?\u1b38$"), [
            ["\u0008\u1b39", "", "", "\u1b02", "\u1b03", "\u1b04",
              "", "", "", "", "", ""],
            ["", "", "", "\u1b00", "\u1b01", "",
              "", "", "", "", "", ""]
          ]],
          [RegExp(balicons + "\u1b3f$"), [
            ["\u0008\u1b41", "", "\u1b36", "\u1b02", "\u1b03", "\u1b04",
              "", "", "", "", "", ""],
            ["", "", "", "\u1b00", "\u1b01", "",
              "", "", "", "", "", ""]
          ]],
          [RegExp(balicons + "\u1b42$"), [
            ["\u0008\u1b43", "", "", "\u1b02", "\u1b03", "\u1b04",
              "", "", "", "", "", ""],
            ["", "", "", "\u1b00", "\u1b01", "",
              "", "", "", "", "", ""]
          ]],
          [RegExp(balicons + "\u1b3a$"), [
            ["\u0008\u1b3b", "", "", "\u1b02", "\u1b03", "\u1b04",
              "", "", "", "", "", ""],
            ["", "", "", "\u1b00", "\u1b01", "",
              "", "", "", "", "", ""]
          ]],
          [RegExp(balicons + "\u1b3c$"), [
            ["\u0008\u1b3d", "", "", "\u1b02", "\u1b03", "\u1b04",
              "", "", "", "", "", ""],
            ["", "", "", "\u1b00", "\u1b01", "",
              "", "", "", "", "", ""]
          ]],
          [/ᬅ$/, [
            ["\u0008\u1b06", "", "", "\u1b02", "\u1b03", "\u1b04",
              "\u1b44", "", "", "", "", ""],
            ["", "", "", "\u1b00", "\u1b01", "",
              "", "", "", "", "", ""]
          ]],
          [/ᬇ$/, [
            ["\u0008\u1b08", "", "", "\u1b02", "\u1b03", "\u1b04",
              "", "", "", "", "", ""],
            ["", "", "", "\u1b00", "\u1b01", "",
              "", "", "", "", "", ""]
          ]],
          [/ᬉ$/, [
            ["\u0008\u1b0a", "", "", "\u1b02", "\u1b03", "\u1b04",
              "", "", "", "", "", ""],
            ["", "", "", "\u1b00", "\u1b01", "",
              "", "", "", "", "", ""]
          ]],
          [/ᬑ$/, [
            ["\u0008\u1b12", "", "", "\u1b02", "\u1b03", "\u1b04",
              "", "", "", "", "", ""],
            ["", "", "", "\u1b00", "\u1b01", "",
              "", "", "", "", "", ""]
          ]],
          [/ᬋ$/, [
            ["\u0008\u1b0c", "", "", "\u1b02", "\u1b03", "\u1b04",
              "", "", "", "", "", ""],
            ["", "", "", "\u1b00", "\u1b01", "",
              "", "", "", "", "", ""]
          ]],
          [/ᬍ$/, [
            ["\u0008\u1b0e", "", "", "\u1b02", "\u1b03", "\u1b04",
              "", "", "", "", "", ""],
            ["", "", "", "\u1b00", "\u1b01", "",
              "", "", "", "", "", ""]
          ]],
          [/ᬍ\u200c$/, [
            ["\u1b35", "", "", "", "", "",
              "", "", "", "", "", ""],
            ["", "", "", "", "", "",
              "", "", "", "", "", ""]
          ]],
          [/[ᬆᬈᬊᬏᬐᬒᬌᬎ]$/, [
            ["", "", "", "\u1b02", "\u1b03", "\u1b04",
              "", "", "", "", "", ""],
            ["", "", "", "\u1b00", "\u1b01", "",
              "", "", "", "", "", ""]
          ]],
          [RegExp(balicons + "$"), [
            ["\u1b35", "\u1b3e", "\u1b36", "\u1b02", "\u1b03", "\u1b04",
              "\u1b44", "\u1b38", "\u1b3f", "\u1b42", "\u1b3a", "\u1b3c"],
            ["", "", "", "\u1b00", "\u1b01", "\u1b34",
              "", "", "", "", "", ""]
          ]],
          [/$/, [
            ["", "", "", "", "", "",
              "", "", "", "", "", ""]
          ]]
        ],
        cons: [
          [RegExp(balicons + "\u1b44$"), [
            ["ᬳ", "ᬦ", "ᬘ", "ᬭ", "ᬓ", "ᬤ", "ᬢ", "ᬲ", "ᬯ", "ᬮ",
              "ᬫ", "ᬕ", "ᬩ", "ᬗ", "ᬧ", "ᬚ", "ᬬ", "ᬜ"],
            ["ᬡ", "ᬙ", "ᬔ", "ᬥ", "ᬟ", "ᬠ", "ᬣ", "ᬝ", "ᬞ", "ᬰ",
              "ᬱ", "ᬖ", "ᬪ", "ᬨ", "ᬛ", "ᭅ", "ᭈ", "ᭊ"]
          ]],
          [/$/, [
            ["ᬳ", "ᬦ", "ᬘ", "ᬭ", "ᬓ", "ᬤ", "ᬢ", "ᬲ", "ᬯ", "ᬮ",
              "ᬫ", "ᬕ", "ᬩ", "ᬗ", "ᬧ", "ᬚ", "ᬬ", "ᬜ"],
            ["ᬡ", "ᬙ", "ᬔ", "ᬥ", "ᬟ", "ᬠ", "ᬣ", "ᬝ", "ᬞ", "ᬰ",
              "ᬱ", "ᬖ", "ᬪ", "ᬨ", "ᬛ", "ᭅ", "ᭈ", "ᭊ"]
          ]]
        ],
        punc: [
          [/$/, [
            ["᭞", "᭟"]
          ]]
        ]
      }
    },
    numbers: {
      grid: [
        ["punc0", "num1", "num2", "num3", "punc1"],
        ["punc2", "num4", "num5", "num6", "punc3"],
        ["punc4", "num7", "num8", "num9", "punc5"],
        ["letters", "punc6", "num0", "punc7", "backspace"]
      ],
      keys: {
        num: [
          [/$/, [
            ["᭐", "᭑", "᭒", "᭓", "᭔", "᭕", "᭖", "᭗", "᭘", "᭙"]
          ]]
        ],
        punc: [
          [/$/, [
            ["᭚", "᭚᭜᭚",
              "᭛", "᭛᭜᭛",
              "ᬒᬁ", "᭟᭜᭟",
              "᭝", "᭠"]
          ]]
        ],

      }
    }
  }
};

export default layouts;
